import { render, staticRenderFns } from "./RelativeUsers.vue?vue&type=template&id=59921b40&"
import script from "./RelativeUsers.vue?vue&type=script&lang=js&"
export * from "./RelativeUsers.vue?vue&type=script&lang=js&"
import style0 from "./RelativeUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports